import { toast } from 'react-toastify';
import Logger from '../logger';

type NotificationType = 'error' | 'info' | 'success' | 'warn';

export const showNotification = (
  message: string,
  type: NotificationType = 'success'
) => {
  toast[type](message);
  if (type !== 'success') Logger[type](message);
};
